import { FC } from 'react';

import { ButtonDropdown, DropdownMenu, DropdownToggle } from 'reactstrap';

import { FontAwesomeIcon, IconButton, If, Then } from '@hsp/react-component-library';

import { SaveAction } from 'pages/audience/shared/save/components/button/components/action';
import { SaveProps } from 'types/pages/audience-builder/shared/save';
import { s } from 'utilities/strings';

import { useDefaultButtonConfiguration } from './hooks';

const DefaultButton: FC<SaveProps> = ({
  buttonColor = 'primary',
  canSaveTo = true,
  children,
  disabled = false,
  onOpen,
  persist = false,
}) => {
  const {
    actions,
    advanced,
    designatedUser,
    handleSave,
    handleSaveAsMaster,
    handleSaveAsPreBuilt,
    handleSaveTo,
    isDisabled,
    isOpen,
    notMasterfileOwner,
    toggleIsOpen,
  } = useDefaultButtonConfiguration({
    children,
    onOpen,
  });

  return (
    <ButtonDropdown
      isOpen={isOpen}
      toggle={toggleIsOpen}>
      <IconButton
        className="align-items-center d-flex justify-content-center"
        color={buttonColor}
        disabled={disabled || isDisabled || notMasterfileOwner}
        icon={['fas', 'save']}
        onClick={handleSave}
        type="button">
        {s('Site.Save')}
      </IconButton>
      <DropdownToggle
        caret
        color={buttonColor}
        disabled={disabled || isDisabled}>
        <FontAwesomeIcon icon={['fas', 'ellipsis-vertical']} />
      </DropdownToggle>
      <DropdownMenu
        end
        persist={persist}>
        <If condition={canSaveTo}>
          <Then>{() => <SaveAction onAction={handleSaveTo}>{s(['Site.Save', 'Site.To'])}</SaveAction>}</Then>
        </If>
        <SaveAction onAction={handleSaveAsPreBuilt}>{s('Site.Pages.AudienceBuilder.Save.SaveAsPrebuilt')}</SaveAction>
        <SaveAction
          disabled={advanced || !designatedUser}
          onAction={handleSaveAsMaster}>
          {s('Site.Pages.AudienceBuilder.Save.SaveAsMaster')}
        </SaveAction>
        {actions}
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default DefaultButton;
